import Remittance from './Remittance';

export default Remittance;
